import { Component, DestroyRef, ErrorHandler, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { API, UserClientFullDTO } from '../../services/api/api';
import { take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/*
Component to redirect from 'connectClient' to 'client-management/client-connections/create-client-connection'
*/

@Component({
  selector: 'page-connect-client',
  templateUrl: './connect-client.component.html',
  styleUrls: ['./connect-client.component.scss'],
  standalone: false,
})
export class ConnectClientComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private errorHandler: ErrorHandler,
    private api: API,
    private router: Router,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe({
      next: params => {
        this.api
          .shared_Status_status()
          .pipe(takeUntilDestroyed(this.destroyRef), take(1))
          .subscribe({
            next: (user: UserClientFullDTO) => {
              this.router
                .navigate(['/client/' + user.client.id + '/client-management/client-connections'], {
                  queryParams: {
                    token: params.token,
                  },
                })
                .then();
            },
            error: error => {
              this.errorHandler.handleError(error);
            },
          });
      },
      error: error => {
        this.errorHandler.handleError(error);
      },
    });
  }
}
